export default {
  menuLayoutClover: 'menu-clover',
  footerLayoutClover: 'footer-clover',
  dataHome: null,
  menu: null,
  dataTopbar: null,
}
